import Icon from './Icon';

export default function PublicFooter(){
 return <footer className="site-footer">
  <div className="footer-brand"><img src="/assets/logo-floraiq.png" alt="FloraIQ"/><span className="footer-divider"/><img src="/assets/logo-bioma.png" alt="BIOMA"/></div>
  <div className="footer-contact"><strong>Canais de atendimento</strong><span><Icon name="phone" size={14}/> (62) 3524-XXXX</span><span><Icon name="mail" size={14}/> atendimento@goiania.go.gov.br</span></div>
  <div className="footer-links"><a href="#">Sobre o FloraIQ</a><a href="#">Política de Privacidade</a><a href="#">Termos de Uso</a><a href="#">LGPD</a><a href="#">Acessibilidade</a></div>
  <div className="footer-social"><span>▶</span><span>◎</span><span>●</span><span>in</span></div>
  <div className="footer-message"><Icon name="leaf" size={24}/><span>Portal integrado ao <strong>FloraIQ</strong><br/>Goiânia mais verde, hoje e sempre.</span></div>
 </footer>
}
